import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

createApp(App).use(router).use(store).use(Toast, {
    transition: "Vue-Toastification__fade"
}).mount('#app');